var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 mt-3"},[_c('input-date-only-btn',{ref:"dataVencimento",attrs:{"label":"FINANCEIRO.NOVA_DATA_VENCIMENTO","required":""},model:{value:(_vm.form.dataVencimento),callback:function ($$v) {_vm.$set(_vm.form, "dataVencimento", $$v)},expression:"form.dataVencimento"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }